import MyCadastre from "../views/configuration/myRegister";
import PaymentOptions from "../views/configuration/paymentOptions";
import PlansTax from "../views/configuration/plansTax";
import Password from "../views/configuration/password";
// import Documents from "../views/configuration/documents";

import General from "../views/configuration/general";

//Assets
import MyCadastreIcon from "../assets/icons/company.svg";
import MyCadastreIconHover from "../assets/icons/companyHover.svg";
import PaymentOptionsIcon from "../assets/icons/bank.svg";
import PaymentOptionsIconHover from "../assets/icons/bankHover.svg";
import PasswordIcon from "../assets/icons/password.svg";
import PasswordIconHover from "../assets/icons/passwordHover.svg";
import DocumentsIcon from "../assets/icons/cloud.svg";
import DocumentsIconHover from "../assets/icons/cloudHover.svg";

import BankHoverIcon from "../assets/icons/bankHover.svg";
import BankIcon from "../assets/icons/bank.svg";
import Configuration from "../views/configurationAdmin/myRegister";
import Bank from "../views/configurationAdmin/banks";
import Documents from "../views/configurationAdmin/document";


const routesConfiguration = [
    {
        id: "cm1",
        path: "/my-cadastre",
        name: "Meu Cadastro",
        icon: MyCadastreIcon,
        iconHover: MyCadastreIconHover,
        layout: "/configuration",
        component: Configuration,
        redirect: false,
    },
    {
        id: "cm1",
        path: "/bank",
        name: "Banco",
        icon: BankIcon,
        iconHover: BankHoverIcon,
        layout: "/configuration",
        component: Bank,
        redirect: false,
    },
    {
        id: "cm1",
        path: "/documents",
        name: "Documentos",
        icon: DocumentsIcon,
        iconHover: DocumentsIconHover,
        layout: "/configuration",
        component: Documents,
        redirect: false,
    },
]

export default routesConfiguration;